const styles = (theme) => ({
  root: {
    display: "inline-block",
  },
  labelDisabled: {
    color: theme.hv.palette.atmosphere.atmo5,
  },
  childGutter: {
    paddingBottom: "6px",
  },
});

export default styles;
